export const BASE_URL = "https://lms-backend-app.onrender.com/api/v1";
// export const BASE_URL = "http://localhost:4000/api/v1"
// import CONFIG from "../config";
// export const BASE_URL = CONFIG.BASE_URL; 
// export const BASE_URL = "http://www.byshelb.by.gov.ng"; 
// export const BASE_URL = "https://byshelb-server.onrender.com/api/v1"
//"https://byshelbserver-e74cea390d4d.herokuapp.com/api/v1"
//"https://byshelbapp-f51726afc8a2.herokuapp.com/api/v1"
